import React, { useState } from 'react';
import axios from 'axios';

function DeleteModal({ isOpen, onClose, recording, apiUrl, secret, apiBaseUrl, onDeleted }) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen || !recording) return null;

  const handleDelete = async () => {
    setDeleting(true);
    setError('');
    try {
      await axios.post(`${apiBaseUrl}/api/recordings/delete`, {
        apiUrl,
        secret,
        recordID: recording.recordID
      });
      onDeleted(recording.recordID);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete recording.');
      setDeleting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '480px' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ borderBottomColor: 'var(--danger-light)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: 'var(--danger)', display: 'flex' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </span>
            <h3 className="modal-title" style={{ color: 'var(--danger-text)' }}>Delete Recording</h3>
          </div>
          <button className="btn-icon" onClick={onClose} aria-label="Close modal">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {error && (
            <div style={{ padding: '0.75rem', background: 'var(--danger-light)', color: 'var(--danger-text)', borderRadius: 'var(--radius-md)', marginBottom: '1rem', fontSize: '0.85rem' }}>
              {error}
            </div>
          )}

          <p style={{ fontSize: '0.9rem', color: 'var(--slate-700)', marginBottom: '1rem' }}>
            Are you sure you want to permanently delete this BigBlueButton recording? This action cannot be undone.
          </p>

          <div style={{ background: 'var(--slate-100)', padding: '0.85rem', borderRadius: 'var(--radius-md)', fontSize: '0.825rem' }}>
            <div style={{ marginBottom: '4px' }}>
              <strong>Meeting:</strong> {recording.name || 'Untitled Meeting'}
            </div>
            <div style={{ marginBottom: '4px', wordBreak: 'break-all' }}>
              <strong>Record ID:</strong> <code>{recording.recordID}</code>
            </div>
            {recording.startTime && (
              <div>
                <strong>Recorded:</strong> {new Date(Number(recording.startTime)).toLocaleString()}
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary btn-sm" onClick={onClose} disabled={deleting}>
            Cancel
          </button>
          <button className="btn btn-danger btn-sm" onClick={handleDelete} disabled={deleting}>
            {deleting ? 'Deleting...' : 'Permanently Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;
